import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {X9ContentViewStore} from '../../common/X9ContentViewStore';
import {StudentSyncedAudio} from '../classroom/student/StudentSyncedAudio';
import {TeacherSyncedAudio} from '../classroom/teacher/TeacherSyncedAudio';

interface Props {
  x9: X9Content | X9ContentSnapshot;
}

@observer
export class X9SyncedAudioView extends React.Component<Props> {
  readonly store: X9ContentViewStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new X9ContentViewStore(props.x9);
  }

  render() {
    const store = this.store;
    const x9 = this.props.x9;
    return (
      <div className="row">
        <div className="col">
          <TeacherSyncedAudio x9={x9} store={store}/>
        </div>
        <div className="col">
          <StudentSyncedAudio x9={x9} store={store}/>
        </div>
      </div>);
  }
}
